/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Floating_Choose_PrimaryInputs */



/**
* | output |
* | --- |
* | "Choose the primary space for this dialog." |
*
* @param {Spaces_Floating_Choose_PrimaryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_floating_choose_primary = /** @type {((inputs?: Spaces_Floating_Choose_PrimaryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Floating_Choose_PrimaryInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie den primären Space für diesen Dialog.")
	return /** @type {LocalizedString} */ ("Choose the primary space for this dialog.")
});